import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import bbt1 from '../img/BBT/bbt1.jpg'
import bbt2 from '../img/BBT/bbt2.jpg'

function BusbarSystem() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  // const features = [
  //   'Efficient Power Distribution',
  //   'Space Saving Design',
  //   'Quick Installation',
  //   'High Current Capacity',
  //   'Expandable Layout',
  //   'Enhanced Safety',
  //   'Modular Sections',
  //   'Easy Maintenance',
  //   'Environment Friendly',
  //   'Fire Resistant Build',
  //   'Voltage Drop Reduction',
  //   'Low Energy Loss',
  // ];

  return (
    <section className="py-5 bg-light mt-5" id="busbar-system">
      <div className="container">
        {/* Title */}
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold">⚡ Busbar Trunking System (BBT)</h2>
          <p className="text-muted">
            Busbar Trunking (BBT) is a reliable and efficient system used for power distribution in large-scale industrial, commercial, and residential buildings. It is commonly employed in power generation plants, substations, data centers, and high-rise buildings to distribute electrical power from the main distribution board to various loads, minimizing power loss and improving safety.
          </p>
        </div>

        {/* Feature Cards */}
        {/* <div className="row g-3 mb-5" data-aos="fade-up">
          {features.map((item, index) => (
            <div
              key={index}
              className="col-6 col-md-4 col-lg-2"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="border bg-white text-center p-3 rounded shadow-sm h-100 hover-shadow">
                <i className="bi bi-lightning-fill text-primary fs-4 mb-2"></i>
                <p className="mb-0 small fw-medium text-muted">{item}</p>
              </div>
            </div>
          ))}
        </div> */}

        {/* Images */}
        <div className="row mb-5" data-aos="zoom-in">
          <div className="col-md-6 mb-3">
            <img
              src={bbt1}
              alt="Busbar Trunking System"
              className="img-fluid rounded shadow"
              style={{ maxHeight: '350px', objectFit: 'cover', width: '100%' }}
            />
          </div>
          <div className="col-md-6 mb-3">
            <img
              src={bbt2}
              alt="Busbar System Setup"
              className="img-fluid rounded shadow"
              style={{ maxHeight: '325px', objectFit: 'cover', width: '100%' }}
            />
          </div>
        </div>

        {/* Ratings */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-primary">📏 Ratings</h4>
          <ul className="text-muted">
            <li><strong>Voltage Class:</strong> Up to 1000V AC</li>
            <li><strong>Current Rating:</strong> 25A to 6300A</li>
            <li><strong>Short Circuit Withstand:</strong> Up to 100kA for 1 sec</li>
            <li><strong>Frequency:</strong> 50/60 Hz</li>
          </ul>
        </div>

        {/* Key Features */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-success">✨ Key Features</h4>
          <ul className="text-muted">
            <li>Aluminum or copper conductors</li>
            <li>IP55/IP65 enclosure ratings</li>
            <li>Fire-retardant, heat-resistant, vibration-proof</li>
            <li>Space-saving and fast installation compared to traditional cabling</li>
            <li>Easy to maintain and expandable for future loads</li>
          </ul>
        </div>

        {/* Description */}
        <div className="mb-5" data-aos="fade-up">
          <p className="text-muted lead">
            A Busbar Trunking System is an efficient and flexible electrical distribution solution that uses busbars—
            conductive metal bars—to transmit power across a facility. These systems are ideal for high-power applications
            in commercial and industrial environments.
          </p>
        </div>

        {/* Benefits */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-success">Benefits</h4>
          <ul className="text-muted">
            <li><strong>Space Efficiency:</strong> Compact installation compared to traditional cabling.</li>
            <li><strong>Flexibility:</strong> Easily reconfigurable for evolving power requirements.</li>
            <li><strong>High Current Capacity:</strong> Handles large loads for industrial needs.</li>
            <li><strong>Reduced Installation Time:</strong> Simple connections mean faster deployment.</li>
            <li><strong>Improved Safety:</strong> Enclosed system minimizes risks of shock or fire.</li>
          </ul>
        </div>

        {/* Applications */}
        <div className="mb-4" data-aos="fade-up">
          <h4 className="text-info">Applications</h4>
          <ul className="text-muted">
            <li><strong>Industrial Facilities:</strong> Powering heavy machinery and production lines.</li>
            <li><strong>Commercial Buildings:</strong> Power distribution for malls, offices, and data centers.</li>
            <li><strong>Power Plants:</strong> Electrical routing in substations and generator units.</li>
            <li><strong>Transportation Infrastructure:</strong> Airports and rail systems’ power supplies.</li>
          </ul>
        </div>

        {/* CTA */}
        <div
          className="p-4 bg-white border-start border-4 border-primary rounded shadow-sm"
          data-aos="fade-up"
        >
          <h5 className="text-dark fw-semibold">Need Busbar Solutions?</h5>
          <p className="mb-2 text-muted">
            Reach out to us for customized design and implementation services.
          </p>
          <a
            href="/contact"
            className="btn"
            style={{
              backgroundColor: '#08717A',
              color: '#fff',
              border: 'none',
            }}
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default BusbarSystem;
